import { Star } from "lucide-react";
import { REVIEWS } from "../../data";
import { Reveal } from "./primitives";

const Stars = ({ className = "" }) => (
  <div className={`flex gap-1 ${className}`} aria-label="5 out of 5 stars">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-brand-red text-brand-red" />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="reviews" data-testid="reviews" className="relative py-24 md:py-36 px-6 md:px-12 lg:px-16 bg-brand-black">
    <Reveal>
      <span className="font-mono-p text-xs uppercase tracking-[0.28em] text-brand-red">What Clients Say</span>
      <h2 className="mt-4 mb-14 md:mb-20 font-anton uppercase text-5xl md:text-7xl tracking-tight leading-[0.9]">
        Straight Talk<br />From The Field.
      </h2>
    </Reveal>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-concrete border border-brand-concrete">
      <Reveal>
        <div data-testid="reviews-aggregate" className="bg-brand-asphalt h-full p-8 md:p-10 flex flex-col justify-between min-h-[280px]">
          <Stars />
          <div>
            <span className="font-anton text-7xl md:text-8xl leading-none text-white">5.0</span>
            <p className="mt-3 font-mono-p text-xs uppercase tracking-[0.2em] text-white/50">
              Average Rating<br />{REVIEWS.length} Client Reviews
            </p>
          </div>
        </div>
      </Reveal>

      {REVIEWS.map((r, i) => (
        <Reveal key={i} delay={((i + 1) % 3) * 0.08}>
          <div data-testid={`review-card-${i}`} className="bg-brand-black h-full p-8 md:p-10 flex flex-col justify-between min-h-[280px] group hover:bg-brand-asphalt transition-colors duration-400">
            <div>
              <Stars className="mb-5" />
              <p className="font-ibm text-white/70 leading-relaxed">"{r.text}"</p>
            </div>
            <div className="mt-8 flex items-end justify-between gap-4">
              <div>
                <span className="font-anton uppercase text-lg tracking-wide text-white">{r.name}</span>
                <p className="font-mono-p text-[11px] uppercase tracking-[0.15em] text-white/40 mt-1">{r.location}</p>
              </div>
              <span className="font-mono-p text-[10px] uppercase tracking-[0.15em] text-brand-red border border-brand-concrete px-3 py-1.5 whitespace-nowrap">
                {r.service}
              </span>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
